/**
 login-view
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";

const template = require("./template.pug");
require("./style.scss");

export default Backbone.View.extend({
  initialize(container) {
    this.render(container);
    this.initElements();
  },

  render() {
    this.$el.html(template);
  },

  initElements() {
    this.$mainView = $(this.$(".main-view"));
    this.$content = $(this.$(".modal-content"));
  },

  show() {
    this.$mainView.modal({ show: true });
  },

  hide() {
    this.$mainView.modal("hide");
  },

  showPage(page, options) {
    this.$content.html(page.$el);
    page.reset(options);
    page.delegateEvents();
  },

  reset() {
    this.initElements();
    this.delegateEvents();
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/main/main-view.js